/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useRef, forwardRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import theme from "../../theme/settings";
import { ButtonIcon } from '..';
const ListItemAction = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  children,
  name,
  className,
  style,
  onClick,
  refs,
  ...props
}, ref) => {
  if (!ref) {
    ref = useRef(null);
  }
  const ListItemActionRoot = css`
            display: flex;
            position: relative;
            align-items: center;
            max-height: 24px;
            margin-left: 16px;
            line-height: 40px;
            color: ${theme.colors.system.active};
            background-color: transparent;
            box-sizing: border-box;
            order: 3;
            z-index: 1;
        `;
  useEffect(() => {
    if (refs) refs(ref);
  }, []);
  const ListItemActionView = useMemo(() => {
    let node = children;
    if (!node) {
      node = jsx(ButtonIcon, {
        viewType: 'ghost',
        name: name,
        onClick: onClick
      });
    }
    return jsx("div", {
      className: 'DGN-UI-List-Item-Action ' + className,
      css: ListItemActionRoot,
      ref: ref,
      style: style,
      ...props
    }, node);
  }, [children, name, style]);
  return ListItemActionView;
}));
ListItemAction.defaultProps = {
  className: ''
};
ListItemAction.propTypes = {
  /** the name of icon to display in ListItemAction (used instead of children) */
  name: PropTypes.string,
  /** classes name for list item action */
  className: PropTypes.string,
  /** the function to get ref of ListItemAction */
  refs: PropTypes.func,
  /** the function for click event */
  onClick: PropTypes.func,
  /** style inline of ListItemAction */
  style: PropTypes.object,
  /** content to display in ListItem */
  children: PropTypes.node
};
export default ListItemAction;